export const LABELS = {
  ACTIONS: {
    NAVIGATE_TO_PAYOUT: ['pages.pwcOrders.list.components.actions.navigateToOrder', 'Open Payout Details'],
    COPY_ORDER_ID: ['pages.pwcOrders.list.components.actions.copyOrderId', 'Copy Payout ID'],
    COPY_CUSTOMER_EMAIL: ['pages.pwcOrders.list.components.actions.copyCustomerEmail', 'Copy User E-mail'],
  },
};
